
const BASE_AJAX_URL = "https://voipdialing.com/ajax/";

const GET_DID_ENDPOINT = BASE_AJAX_URL + "get-dids/areacode/";
//const ADD_DID_TO_CART_ENDPOINT = BASE_AJAX_URL + "add-did/";
//const REMOVE_DID_TO_CART_ENDPOINT = BASE_AJAX_URL + "remove-did/";

//const ADD_PBX_TO_CART_ENDPOINT = BASE_AJAX_URL + "add-pbx/";

const BULK_SMS_CONTACT_ENDPOINT = BASE_AJAX_URL + "contact/";

//const GET_SESSION_ENDPOINT = BASE_AJAX_URL + "get-session/";

export const DIDS_TIME_LIMIT = 60 * 60000; //60 minutes in milliseconds



export const generateGetDIDs = (areaCode) => {
    return GET_DID_ENDPOINT + areaCode;
}
// export const generateRemoveDIDFromCart = (id, number, price, setup, api) => {
//     return REMOVE_DID_TO_CART_ENDPOINT + `id/${id}/number/${number}/price/${price}/setup/${setup}/api/${api}`;
// }
// export const generateAddDIDToCart = (id, number, price, setup, api) => {
//     return ADD_DID_TO_CART_ENDPOINT + `id/${id}/number/${number}/price/${price}/setup/${setup}/api/${api}`;
// }

// export const generateAddPBXToCart = (id) => {
//     return ADD_PBX_TO_CART_ENDPOINT + `id/${id}`;
// }

export const generateBulkSmsContact = (name, email, phone, smstot, message) => {
    //returns 'Success' or 'Failure'
    return `${BULK_SMS_CONTACT_ENDPOINT}name/${name}/email/${email}/phone/${phone}/smstot/${smstot}/message/${message}`;
}


//export const CAMPAIGN_PRICE_LIMIT = 3000;
export const CAMPAIGN_MESSAGES_LIMIT = 3000000;

export const APP_BASENAME = "shop";

export const APP_ENDPOINTS = ["phone-numbers","hosted-pbx", "dialing-plan", "sms", "equipment"];
